// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogDuplicationForm from "../../modules/Catalog/CatalogDuplicationForm.res.js";
import * as CatalogDuplicationFormSourceCard from "../../modules/Catalog/CatalogDuplicationFormSourceCard.res.js";
import * as CatalogDuplicationFormPageActions from "../../modules/Catalog/CatalogDuplicationFormPageActions.res.js";
import * as CatalogDuplicationFormSelectionTableCard from "../../modules/Catalog/CatalogDuplicationFormSelectionTableCard.res.js";

function CatalogDuplicationPage(props) {
  let duplicationMode = props.duplicationMode;
  let references = props.references;
  let cku = props.cku;
  let state = CatalogDuplicationForm.useFormState();
  let notifier = Notifier.use(undefined, undefined);
  ReactUpdateEffect.use1(() => {
    notifier.clear();
  }, [state.values.source]);
  let renderActions = () => JsxRuntime.jsx(CatalogDuplicationFormPageActions.make, {
    duplicationMode: duplicationMode
  });
  let title;
  title = duplicationMode === "Product" ? I18n.t("Duplicate the product and its variants") : I18n.t("Duplicate the variant");
  let subtitle = React.useMemo(() => {
    let match = state.values.source;
    let tmp;
    if (match !== undefined) {
      let shopId = match._0.shopId;
      tmp = shopId !== undefined ? references.find(reference => reference.shopId === shopId) : references[0];
    } else {
      tmp = references[0];
    }
    return Stdlib_Option.mapOr(tmp, "...", param => param.formattedName);
  }, [
    references,
    state.values.source
  ]);
  let reference = React.useMemo(() => {
    let match = state.values.source;
    if (match === undefined) {
      return;
    }
    let shopId = match._0.shopId;
    if (shopId !== undefined) {
      return references.find(reference => reference.shopId === shopId);
    }
  }, [state.values.source]);
  let tmp;
  tmp = duplicationMode === "Product" ? "product and its variants" : "variant";
  let tmp$1;
  tmp$1 = duplicationMode === "Product" ? "product and its variants" : "variant";
  return JsxRuntime.jsxs(Page.make, {
    children: [
      JsxRuntime.jsx(Notifier.Banner.make, {
        notifier: notifier
      }),
      JsxRuntime.jsx(Box.make, {
        spaceBottom: "xxlarge"
      }),
      JsxRuntime.jsx(Stack.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsxs(Group.make, {
              children: [
                JsxRuntime.jsxs(Stack.make, {
                  children: [
                    JsxRuntime.jsx(Title.make, {
                      children: I18n.t("Shop catalog to duplicate"),
                      level: 3,
                      weight: "bold"
                    }),
                    JsxRuntime.jsx(TextStyle.make, {
                      children: I18n.t("Select the shop catalog from which the " + (tmp + " will be duplicated.")),
                      variation: "normal"
                    })
                  ],
                  space: "small"
                }),
                JsxRuntime.jsx(CatalogDuplicationFormSourceCard.make, {
                  shopsData: props.shopsData,
                  references: references.map(param => ({
                    id: param.id,
                    shopId: param.shopId
                  })),
                  duplicationMode: duplicationMode
                })
              ],
              grid: [
                "25%",
                "75%"
              ],
              wrap: false,
              spaceX: "xlarge"
            }),
            JsxRuntime.jsxs(Group.make, {
              children: [
                JsxRuntime.jsxs(Stack.make, {
                  children: [
                    JsxRuntime.jsx(Title.make, {
                      children: I18n.t("Shop catalog to duplicate"),
                      level: 3,
                      weight: "bold"
                    }),
                    JsxRuntime.jsx(TextStyle.make, {
                      children: I18n.t("Select the shop catalog from which the " + (tmp$1 + " will be duplicated.")),
                      variation: "normal"
                    })
                  ],
                  space: "small"
                }),
                JsxRuntime.jsx(CatalogDuplicationFormSelectionTableCard.make, {
                  reference: reference !== undefined ? ({
                      variantsCku: reference.variantsCku,
                      productName: reference.productName,
                      productKind: reference.productKind,
                      productColor: reference.productColor,
                      productProducer: reference.productProducer
                    }) : undefined,
                  duplicationMode: duplicationMode,
                  onError: duplicationStatus => {
                    let tmp;
                    if (duplicationMode === "Product") {
                      tmp = "The product of the target catalog cannot be duplicated as its reference already exists inside the catalogs of all your shops.";
                    } else {
                      switch (duplicationStatus) {
                        case "Duplicable" :
                        case "ExistsAlready" :
                          tmp = "The variant of the target catalog cannot be duplicated because no reference matches the duplication criteria.";
                          break;
                        case "MissingProduct" :
                          tmp = I18n.template(I18n.t("You cannot duplicate the product variant only. It is necessary to duplicate the whole product. [Duplicate product]({{link}})"), {
                            link: `/catalog/product/duplication/` + cku
                          }, undefined);
                          break;
                      }
                    }
                    notifier.reset({
                      TAG: "Warning",
                      _0: I18n.t(tmp)
                    }, undefined, undefined);
                  }
                })
              ],
              grid: [
                "25%",
                "75%"
              ],
              wrap: false,
              spaceX: "xlarge"
            })
          ],
          space: "medium"
        }),
        space: "xxlarge"
      })
    ],
    title: title,
    subtitle: subtitle,
    renderActions: renderActions
  });
}

let make = React.memo(CatalogDuplicationPage);

let Config;

export {
  Config,
  make,
}
/* make Not a pure module */
